module.exports = __webpack_public_path__ + "img/other.0598daa9.svg";